import { Text } from '../../components/Text';
import { RadioButtonGroupProps } from '../../components/RadioButtonGroup';
import { appThemeNames } from '../../constants/constants';

export const options: RadioButtonGroupProps['options'] = [
    {
        value: appThemeNames.BLACK_ON_WHITE,
        label: <Text text="Black on white" fontWeight="semibold" variant="heading" />,
        helperText: <Text text="Choose this mode to see how your screen will look" />,
    },
    {
        value: appThemeNames.WHITE_ON_BLACK,
        label: <Text text="White on black" fontWeight="semibold" variant="heading" />,
        helperText: <Text text="Choose this mode to see how your screen will look" />,
    },
    {
        value: appThemeNames.YELLOW_ON_BLACK,
        label: <Text text="Yellow on black" fontWeight="semibold" variant="heading" />,
        helperText: <Text text="Choose this mode to see how your screen will look" />,
    },
];
